import { Message } from 'stompjs';
import type { AppDispatch } from 'store';
import turnActions from 'Turn/services/actions';
import storage from 'utils/sessionStorage';
import {
  APPOINTMENT_TOPIC,
  APPOINTMENT_UPDATED_TOPIC,
  INBOUND_CALL_BOOKING_TOPIC,
  SYNC_TURN,
} from 'utils/socket';
import { dateParamSignal } from 'CalendarFilter/DatePicker';
import CallerId from 'widgets/CallerId';
import CallerV2 from 'Calendar/CallerV2';
import { isCallerV2Enabled } from 'Calendar/CallerV2/feature-flag';
import { toCalendarDateParam } from './calendar-refresh-date';
import { isLocalCalendarMutationInFlight } from './local-calendar-mutation';
import aptActions from './actions/apt';
import { aptUIActions } from './reducers/apt';
import { IInboundCallBookingResData } from './types/apt';
import { IAppointmentResItem } from './types/response';

export type TopicSubscription = {
  destination: string;
  handler: (message: Message) => void;
};

/**
 * Danh sach destination ma mot phien socket phai giu subscription, kem handler.
 *
 * Dung chung cho ca luc subscribe va luc health check doi chieu, de hai ben khong
 * bao gio lech nhau khi them hay doi topic.
 */
export const buildTopicSubscriptions = (shopId: string, dispatch: AppDispatch): TopicSubscription[] => {
  const deviceCode = storage.deviceCode.get();
  const inboundCallDestination = deviceCode
    ? `${INBOUND_CALL_BOOKING_TOPIC}/${shopId}/${deviceCode}`
    : `${INBOUND_CALL_BOOKING_TOPIC}/${shopId}`;

  return [
    {
      // Phai tai lai dung ngay dang xem. Lay `moment()` o day se tai ngay hom nay va
      // response do thay nguyen `calendar.data`, xoa sach lich cua ngay user dang mo.
      // Doc signal ngay trong handler: subscription song suot phien nen capture ra
      // ngoai se dong bang ngay tai luc connect.
      destination: `${APPOINTMENT_TOPIC}/${shopId}`,
      handler: () => {
        // Chinh may nay dang dat hoac sua lich: broadcast nay la tieng vong cua
        // thao tac do. No toi truoc response nen ngay dang xem van la ngay cu, tai
        // lai bay gio chi de vut bo. Luong dat lich tu tai lai dung ngay cua no.
        if (isLocalCalendarMutationInFlight()) return;
        dispatch(aptActions.calendar.getData.fetch({
          shopId,
          startTime: toCalendarDateParam(dateParamSignal.value),
        }));
      },
    },
    {
      // Ticket cua mot lich vua doi trang thai thanh toan. Topic mang nguyen
      // appointment detail nen chi can ghi de item, khong phai tai lai ca ngay.
      destination: `${APPOINTMENT_UPDATED_TOPIC}/${shopId}`,
      handler: (message: Message) => {
        try {
          const apt: IAppointmentResItem = JSON.parse(message.body);
          // Ban so it chi map de len lich DANG hien; lich vua thanh toan co the
          // thuoc ngay khac ngay dang xem, ban so nhieu se chen no vao nham ngay.
          if (apt?.id != null) dispatch(aptUIActions.upsertAppointment(apt));
        } catch {
          // Payload hong thi bo qua, khong de mot message lam chet ca socket.
        }
      },
    },
    {
      destination: `${SYNC_TURN}/${shopId}`,
      handler: () => dispatch(turnActions.data.listStaffs.fetch()),
    },
    {
      destination: inboundCallDestination,
      handler: (message: Message) => {
        if (isCallerV2Enabled()) {
          CallerV2.open();
          return;
        }
        const data: IInboundCallBookingResData = JSON.parse(message.body);
        CallerId.open({ callId: data.callerId, customer: { id: data.customerId, name: data.customerName || '', phone: data.phone } });
      },
    },
  ];
};
